const actions = {
    Get: "FILETYPE.GET",
    Got: "FILETYPE.GOT",
    GetErrored: "FILETYPE.ERRORED",
    Select: "FILETYPE.SELECT",
    DeSelect: "FILETYPE.DESELECT"
};

module.exports = actions;


// WEBPACK FOOTER //
// ./src/actions/FileTypeActions.js